import { CardContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { Illustration, Text, useModalState } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { ShiftDetailsInnerCard } from "../InnerCard";
import { CancellationProtectionTermsBottomSheet } from "./CancellationProtectionTermsBottomSheet";
import { SegmentedText } from "./SegmentedText";
import { getCancellationProtectionPolicyDescription } from "./utils/getCancellationProtectionDescription";

interface CancellationProtectionPolicyCardProps {
  formattedPayAmount?: string;
  cancellationProtectionWindowInHours: number;
  isSentHomeProtected: boolean;
  workplaceName: string;
  workplaceId?: string;
}

export function CancellationProtectionPolicyCard(props: CancellationProtectionPolicyCardProps) {
  const {
    formattedPayAmount,
    cancellationProtectionWindowInHours,
    isSentHomeProtected,
    workplaceName,
    workplaceId,
  } = props;
  const termsModalState = useModalState();

  const descriptionSegments = getCancellationProtectionPolicyDescription(
    formattedPayAmount,
    cancellationProtectionWindowInHours,
    isSentHomeProtected
  );

  return (
    <>
      <ShiftDetailsInnerCard
        footer={
          <Button
            fullWidth
            variant="outlined"
            size="medium"
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CANCELLATION_PROTECTION_POLICY_CARD_VIEW_TERMS_CLICKED, {
                workplaceId,
                cancellationProtectionWindowInHours,
                isSentHomeProtected,
              });
              termsModalState.openModal();
            }}
          >
            View terms
          </Button>
        }
      >
        <CardContent>
          <Stack spacing={4} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
            <Illustration type={isRebrandingEnabled() ? "parachute-gift" : "parachute-blue"} />
            <Text semibold variant="h5" sx={{ textAlign: "center" }}>
              Cancellation Protection
            </Text>
            <SegmentedText
              segments={descriptionSegments}
              sx={{ color: (theme) => theme.palette.text.secondary, textAlign: "center" }}
            />
          </Stack>
        </CardContent>
      </ShiftDetailsInnerCard>
      <CancellationProtectionTermsBottomSheet
        modalState={termsModalState}
        cancellationProtectionWindowInHours={cancellationProtectionWindowInHours}
        isSentHomeProtected={isSentHomeProtected}
        workplaceName={workplaceName}
        workplaceId={workplaceId}
      />
    </>
  );
}
